import { useTranslation } from "react-i18next";
import Section from "components/layout/section";
import SectionHeader from "components/layout/sectionHeader";
import SectionHeaderTitle from "components/layout/sectionHeaderTitle";
import PageTitle from "features/navigation/pageTitle";
import RightSidebar from "@/components/sidebar/right/RightSidebar";
import AccountGeneralSettingsForm from "@/features/account/accountGeneralSettingsForm";
import { use, useEffect } from "react";
import useAuth from "@/hooks/useAuth";
import { useNavigate } from "react-router-dom";

const CompleteAccountPage = () => {

    const { t } = useTranslation()
    const navigate = useNavigate();

    const {
        accountPublicData
    } = useAuth();

    useEffect(() => {
        if (accountPublicData?.other.isComplete) {
            navigate('/storages', { replace: true });
        }
    }, [accountPublicData, navigate]);

    return (
        <>
            <PageTitle title={t('titleCompleteAccount')} />
            <Section>
                <AccountGeneralSettingsForm />
            </Section>
            <RightSidebar />
        </>
    );
}

export default CompleteAccountPage

